module.exports = __webpack_public_path__ + "static/media/prestador.8699b12e.svg";